module.exports = __webpack_public_path__ + "static/media/chi.e88ee4bd.png";